export default function getResource() {
    return {
        top: 'Haut',
        details: 'Détails',
        similar: 'Similaire',
        qAndA: 'Q et R',
        reviews: 'Avis',
        navLabel: 'Navigation de la page produit'
    };
}
